import { InputFieldProps } from "../../types/types";
import { Input } from "@/components/ui/input";
const InputField: React.FC<InputFieldProps> = ({
  type,
  name,
  placeholder,
  value,
  onChange,
  style = "",
  required,
  icon,
  onClick,
  props,
}) => {
  return (
    <div className="relative w-full">
      {/* <input
        type={type}
        name={name}
        id={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        className={`2xl:h-[55px] 2xl:text-lg w-full rounded-xl py-2.5 2xl:py-3 ${style}`}
        /> */}

      <Input type={type}
        name={name}
        id={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="pr-8"
        required={required} {...props} />
      {icon &&
        <div className="absolute top-1/2 right-1 -translate-y-1/2 text-gray-400" onClick={onClick}>
          <img src={icon} alt="." width={20} />
        </div>

      }
    </div>
  );
};

export default InputField;
